// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris


import {
  Button,
  makeStyles,
  mergeClasses,
  type ButtonProps,
} from "@fluentui/react-components";
import { QuestionCircle24Regular } from "@fluentui/react-icons";
import { useTutorial } from "../context/TutorialContext";
import type { TourKind } from "../dto/tourModels";
import { COMPACT_VIEWPORT_QUERY } from "../../../hooks/useMediaQuery";

const useStyles = makeStyles({
  compactLabel: {
    [`@media ${COMPACT_VIEWPORT_QUERY}`]: {
      display: "none",
    },
  },
  compactButton: {
    [`@media ${COMPACT_VIEWPORT_QUERY}`]: {
      minWidth: "32px",
      paddingLeft: "6px",
      paddingRight: "6px",
    },
  },
});

export interface TutorialToggleProps {
  kind?: TourKind;
  label?: string;
  appearance?: ButtonProps["appearance"];
  compactIconOnly?: boolean;
}

export function TutorialToggle({
  kind = "workspace",
  label = "Take a Tour",
  appearance = "subtle",
  compactIconOnly = false,
}: TutorialToggleProps) {
  const styles = useStyles();
  const { start, isActive } = useTutorial();

  return (
    <Button
      appearance={appearance}
      icon={<QuestionCircle24Regular />}
      disabled={isActive}
      title={label}
      aria-label={label}
      className={mergeClasses(compactIconOnly && styles.compactButton)}
      onClick={() => start(kind)}
    >
      <span className={mergeClasses(compactIconOnly && styles.compactLabel)}>
        {label}
      </span>
    </Button>
  );
}
